import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { formatCommonDateAndTimeStr, handleApiRequestSuccessData, handleRequestError } from '@jove-frontend/uikit';
import { isArray } from 'lodash';
import qs from 'qs';
import { api } from '.';
export var apiGetValidationDocuments = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(validationId, token) {
    var _res$data, res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (validationId) {
              _context.next = 3;
              break;
            }

            throw new Error("Invalid validation id: ".concat(validationId));

          case 3:
            _context.next = 5;
            return api.get('/validation_documents', {
              params: {
                validation_id: validationId,
                sort_column: 'created_at',
                sort_order: 'DESC',
                token: token
              }
            });

          case 5:
            res = _context.sent;

            if (isArray((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data.forEach(function (item) {
                if (item.validation_document) {
                  item.validation_document['createdAtText'] = formatCommonDateAndTimeStr(item.validation_document.created_at);
                  item.validation_document['updatedAtText'] = formatCommonDateAndTimeStr(item.validation_document.updated_at);
                }
              });
            }

            return _context.abrupt("return", [res.data.data]);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch validation documents: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function apiGetValidationDocuments(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var apiGetValidationDocument = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(documentId, payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (documentId) {
              _context2.next = 3;
              break;
            }

            throw new Error("Invalid document id: ".concat(documentId));

          case 3:
            _context2.next = 5;
            return api.get("/validation_documents/".concat(documentId, "?").concat(qs.stringify(payload)));

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data.data]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiGetValidationDocument(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var uploadDocument = function uploadDocument(url, formData, params) {
  return api.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    params: params
  });
};

export var apiUploadValidationDocument = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
    var file, validationId, type, token, country_code, formData, res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            file = _ref3.file, validationId = _ref3.validationId, type = _ref3.type, token = _ref3.token, country_code = _ref3.country_code;
            _context3.prev = 1;
            formData = new FormData();
            formData.append('validation_id', validationId);
            formData.append('file', file);
            formData.append('type', type);

            if (country_code) {
              formData.append('country_code', country_code);
            }

            _context3.next = 9;
            return uploadDocument('/validation_documents', formData, {
              token: token
            });

          case 9:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 13:
            _context3.prev = 13;
            _context3.t0 = _context3["catch"](1);
            message = (_err$response2 = _context3.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to upload document: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 13]]);
  }));

  return function apiUploadValidationDocument(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiUpdateValidationDocument = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(documentId, payload, token) {
    var res, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (documentId) {
              _context4.next = 3;
              break;
            }

            throw new Error("Invalid document id: ".concat(documentId));

          case 3:
            _context4.next = 5;
            return api.patch("/validation_documents/".concat(documentId), payload, {
              params: {
                token: token
              }
            });

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data.data.validation_document]);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            message = (_err$response3 = _context4.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg;
            console.error("Failed to update document: ".concat(message));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));

  return function apiUpdateValidationDocument(_x6, _x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}(); // Query the quote signature document detail info

export var apiGetQuoteSignatureDocumentDetailInfo = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get("/quote_documents/".concat(payload.quote_document_id));

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data]);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0, payload));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function apiGetQuoteSignatureDocumentDetailInfo(_x9) {
    return _ref6.apply(this, arguments);
  };
}(); // Query the document detail info

export var apiGetDocumentDetailInfoWithCommonInterface = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.get("/general/document_download_url/".concat(payload.id));

          case 3:
            res = _context6.sent;
            handleApiRequestSuccessData(res);
            return _context6.abrupt("return", [res.data]);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0, payload));

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));

  return function apiGetDocumentDetailInfoWithCommonInterface(_x10) {
    return _ref7.apply(this, arguments);
  };
}();